<ng-content select="viewer-memo-type"></ng-content>
<div class="box">
  <div class="top-buttons">
    <button
      sui-icon-button
      *ngIf="!!menu"
      class="more-button"
      [cdkMenuTriggerFor]="menu"
      [cdkMenuTriggerData]="menuData"
      [cdkMenuPosition]="_menuPosition"
      (click)="$event.stopPropagation()"
    >
      <sui-icon name="더보기 세로형"></sui-icon>
    </button>
  </div>

  <div class="text" (click)="contentClick.emit()">
    <div class="author-and-date">
      <div class="author">
        <ng-content select="viewer-memo-author"></ng-content>
      </div>
      <div class="date" *ngIf="createdAt">
        {{
          createdAt === updatedAt
            ? (updatedAt | date : 'y. MM. dd. HH:mm')
            : (updatedAt | date : 'y. MM. dd. HH:mm')
        }}
        {{ createdAt === updatedAt ? '' : '(수정됨)' }}
      </div>
    </div>
    <p
      class="content"
      [innerHTML]="
        (limitHeight && _shortContent ? _shortContent + '...' : content)
          | escapeHtml
          | detectLink
      "
    ></p>
    <span
      class="show-all-content-button"
      *ngIf="limitHeight && _shortContent"
      (click)="$event.stopPropagation(); _shortContent = undefined"
      >자세히 보기</span
    >
    <span
      class="show-all-content-button"
      *ngIf="limitHeight && !_shortContent"
      (click)="changeShortContent()"
      >간략히</span
    >
  </div>

  <div class="info" (click)="$event.stopPropagation()">
    <div class="actions">
      <ng-content select="viewer-memo-actions"></ng-content>
    </div>
    <!-- <div class="author" *ngIf="isSingleMode" [class.single-mode]="isSingleMode">
      <ng-content select="viewer-memo-author-single"></ng-content>
    </div> -->
  </div>

  <button
    class="reply-comment-count-button"
    (click)="toggleReplyComment()"
    *ngIf="replyCommentCount > 0"
  >
    <span>답글 {{ replyCommentCount }}개</span>
    <sui-icon name="펼침" *ngIf="!isReplyCommentListOpen"></sui-icon>
    <sui-icon name="닫힘" *ngIf="isReplyCommentListOpen"></sui-icon>
  </button>

  <!-- 답글 영역 -->
  <ng-content
    select="viewer-memo-reply-comment"
    *ngIf="isReplyCommentListOpen || isReplyCommentInputOpen"
  ></ng-content>

  <ng-content select="viewer-memo-caution"></ng-content>
</div>

<div class="footer">
  <div class="tag">
    <ng-content select="viewer-memo-tag"></ng-content>
  </div>
</div>
